import {sessionStartQPKey, sessionStorageAttributesKey} from '@app/analytics/helper'

type Props = {
  queries: Record<string, any>
}

export function setQueriesForCanonical({queries}: Props): Record<string, any> {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') {
    return {}
  }

  const existingData = sessionStorage?.getItem(sessionStorageAttributesKey)
  let storedAttributes: Record<string, any> = {}

  if (existingData) {
    try {
      storedAttributes = JSON.parse(existingData)
    } catch (error) {
      console.error('Error parsing stored attributes:', error)
    }
  }

  const sessionStartPage = storedAttributes[sessionStartQPKey] || queries[sessionStartQPKey]

  const updatedAttributes = {
    ...queries,
    [sessionStartQPKey]: sessionStartPage,
  }
  sessionStorage?.setItem(sessionStorageAttributesKey, JSON.stringify(updatedAttributes))

  return updatedAttributes
}
